var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v("Registro")]),_c('p',[_vm._v("Ingrese sus datos y luego haga click en el botón Registrarme.")]),_c('sign-up-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }